import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/featureFlags`;

export const getFeatureFlags = async (navigate) => {
  try {
    const response = await fetchWithAuth(
      API_URL,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener feature flags");
  } catch (error) {
    throw error;
  }
};

export const updateFeatureFlag = async (flagId, data, navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${flagId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
      navigate
    );

    if (response.ok) {
      const result = await response.json();
      return result;
    }

    throw new Error("Error al actualizar feature flag");
  } catch (error) {
    throw error;
  }
};
